export default {
    header: "You have successfully been logged out",
    message: ""
}